export default __webpack_public_path__ + "static/media/SS.61366b89.png";